<template>
  <div class="l-page-work" id="l-page-work">
    <div class="l-content">
      <slot name="body"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "l-pauses",
  props: {
    headTitle: {
      type: String,
    },
  },
  computed: {},
};
</script>

<style lang="stylus" scoped>
@import './index.styl'
</style>
